// extracted by mini-css-extract-plugin
export var Choices = "styles-module--Choices--18RdQ";
export var Choice_Input = "styles-module--Choice_Input--kXAHH";
export var Choice_Label = "styles-module--Choice_Label--1Oywq";
export var Choice_Label_Checked = "styles-module--Choice_Label_Checked--2sFJq";